import gql from 'graphql-tag'

export default gql`
query listHolidays($params: ListQueryArgs) {
    cashAssist {
      listHolidays(params: $params) {
        hasNextPage
        items {
          id
          name
          date
          day
        }
      }
    }
}`
